//
// Webasyst Captcha
//

( function($, waTheme) {

    $.ajaxSetup({
        cache: false
    });

    var Captcha = ( function($) {

        Captcha = function(options) {
            var that = this;

            // DOM
            that.$window = $(window);

            // VARS

            // DYNAMIC VARS

            // INIT
            that.init();
        };

        Captcha.prototype.init = function() {
            var that = this;

            // Click on refresh button or image
            $(".wa-captcha").on("click", ".wa-captcha-refresh, .wa-captcha-img", function(event) {
                event.preventDefault();
                refreshCaptcha( $(this) );
            });

            // Refresh Captcha
            function refreshCaptcha($target) {
                var $wrapper = $target.closest(".wa-captcha"),
                    captcha = $wrapper.find(".wa-captcha-img");

                if (captcha.length) {
                    var newCaptchaHref = captcha.attr("src").replace( /\?.*$/,'?rid='+Math.random() );

                    captcha.attr("src", newCaptchaHref);

                    captcha.one("load", function() {
                        $wrapper.find('.wa-captcha-input').focus();
                    });
                }

                $wrapper.find("input").val("");
            }
        };

        return Captcha;

    })($);

    waTheme.init.site.Captcha = Captcha;

})(jQuery, window.waTheme);
